export default __webpack_public_path__ + "static/media/circleHalfTp.957fa94b.svg";